function SFAccordian(element) {
  var dom_element = element.get(0);
  if (dom_element.$dynamicSelect) {
    return;
  }
  dom_element.$SFAccordian = this;
  this.$SFAccordian = element;
  this._setObjects();
  this._bindEvents();
}

SFAccordian.prototype._setObjects = function() {
  this.$allTheSFAccordians = $("[data-sf-accordian-target]");
  this.$toggle = this.$SFAccordian.find("[data-sf-accordian-toggle]");
  this.$target = this.$SFAccordian.find("[data-sf-accordian-target]");
};

SFAccordian.prototype._bindEvents = function() {
  this.$toggle.on("click touchstart", $.proxy(this._toggleExpansion, this));
};

SFAccordian.prototype._toggleExpansion = function() {
  this._closeAllTheSFAccordians();
  this.$target.toggleClass("expanded");
};

SFAccordian.prototype._closeAllTheSFAccordians = function() {
  this.$allTheSFAccordians.removeClass("expanded");
};

$(function() {
  $("[data-sf-accordian]").each(function(index, element) {
    new SFAccordian($(element));
  });
});
